import { createApp } from 'vue'
import './index.css';
import gliderHelper from './plugins/js/glider-helper.js'
window.glider = gliderHelper

import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from './store/store.js';

import './plugins/js/glider.min.js'
import './plugins/css/glider.min.css'
import CKEditor from '@ckeditor/ckeditor5-vue';
import DKToast from 'vue-dk-toast'

import localforage from 'localforage'
/*
when we install CKEditor please use this commands
npm i @ckeditor/ckeditor5-vue
npm i @ckeditor/ckeditor5-build-classic
*/

import VueApexCharts from "vue3-apexcharts";
/*
when we install ApexChart please use this commands
npm install --save apexcharts
npm install --save vue3-apexcharts
*/

// with npm
// npm install primevue primeicons
// https://primevue.org/calendar/
import PrimeVue from 'primevue/config';
//theme
import "primevue/resources/themes/lara-light-indigo/theme.css";     
//core
import "primevue/resources/primevue.min.css";
//icons
import "primeicons/primeicons.css";

import i18n from './i18n'
import App from './App.vue'
import VCalendar from 'v-calendar';

localforage.config({
    driver: localforage.LOCALSTORAGE,
    storeName: 'smartartclient'
})


window.axios = axios.create({
    baseURL: process.env.VUE_APP_SSO_API_URL || '',
    headers: {
        Accept: 'application/json',
        ProductCode: 'SMART-ART',
        ClientType: 'art-client',
        Authorization: 'Bearer ' + localStorage.getItem("localforage/smartartclient/authtoken")
    }
})

const app = createApp(App).use(i18n).use(store).use(router).use(VueApexCharts).use(CKEditor).use(PrimeVue)
app.use(VueAxios, axios);
app.use(DKToast);
app.use(VCalendar, {});
window.alertDuration = process.env.VUE_APP_ALERT_DURATION || 5000;

//  common functions added by Mukesh Rane to use on all the pages
app.mixin({
    methods: {
        isUserLoggedIn(){
            let userAuthToken = localStorage.getItem("localforage/smartartclient/authtoken");
            if(userAuthToken !== null && userAuthToken != ""){
                return true;
            }
            return false;
        },
        allowLoggedInUserToAccess(){
            let userAuthToken = localStorage.getItem("localforage/smartartclient/authtoken");
            if(userAuthToken !== null && userAuthToken != ""){
                return true;
            }
            window.location = process.env.BASE_URL + 'sign-in';
        },
        NumbersOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        gFormatedAmount(value) {
			return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
		},
		gFormatedNumber (num) {
			return parseFloat(num).toFixed(2);
		},
		gFormatedAmountNumber(num){
			return this.gFormatedAmount(this.gFormatedNumber(num));
		},
        gFormatedAmtNumWithoutDecimal(num){
            let newNumber = Math.floor(num);
            newNumber = newNumber.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");              
			return newNumber;
		},
        gFormatedDate(date){
            let today = new Date(date);
            let dd = String(today.getDate()).padStart(2, '0');
            let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            let yyyy = today.getFullYear();
            return today = dd + '/' + mm + '/' + yyyy;
            //alert(today);
        },
        gFormatDateYMD(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;

            return [year, month, day].join('-');
        },
        gIndicator(status){
            if(status == 'start'){
                document.getElementById("template_loader_indicator").style.display="block";
            }
            if(status == 'stop'){
                document.getElementById("template_loader_indicator").style.display="none";
            }
        },
        getRecordListingSummary(metaData) {
            if (metaData != null) {
                let from = (metaData.from != null) ? metaData.from : 0
                let to = (metaData.to != null) ? metaData.to : 0
                if (from == 0 && to == 0) {
                    return this.$t('no-data-found')
                }
                return this.$t('showing')+ ' '+ from + ' '+this.$t('to')+' ' + to +' '+  this.$t('of') + ' '+ metaData.total + ' ' + this.$t('entries')
            }
           return this.$t('loading-data')
        },
        haspermission(permission){

            let hasPermission = false;
            const permissions = ['sp-bo-my-profile'];
            const getData = JSON.parse(localStorage.getItem("ls_data"));
            const getRoles = getData && getData.hasOwnProperty('roles') ? getData.roles : false;
            
            if(getRoles && getRoles.length){
                for(var i=0; i<getRoles.length; i++){
                    const getPermission = getRoles[i].hasOwnProperty('permissions') ? getRoles[i].permissions : false;

                    if(getPermission && getPermission.length){
                        for(var k=0; k<getPermission.length; k++){
                            if(!permissions.includes(getPermission[k].name)){
                                permissions.push(getPermission[k].name);
                            }
                        }
                    }
                }
            }
            if (permissions.length) {
                hasPermission = permissions.includes(permission) ? true : false;
            }
            return hasPermission;
        },
        async bellNotification(frmData){
            try{
                const result = await this.$store.dispatch("sendBellNotification",{payload: frmData});
            }catch(e){
                console.log('error in bell notification',e);
            }
        },
        titleCase(str) {
            var splitStr = str.toLowerCase().split(' ');
            for (var i = 0; i < splitStr.length; i++) {
                // You do not need to check if i is larger than splitStr length, as your for does that for you
                // Assign it back to the array
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
            }
            // Directly return the joined string
            return splitStr.join(' '); 
        },
        getDateFormate(date){
            if(date){
                const [day, month, year] = date.split('-').map(num => parseInt(num, 10));

                // Create a new Date object using the year, month (0-indexed), and day
                const setdate = new Date(year, month - 1, day); // Month is 0-indexed, so we subtract 1

                // Set the date to Indian Standard Time (GMT +5:30)
                setdate.setHours(0, 0, 0, 0);  // Setting time to midnight

                return setdate.toString();
            }
        }
    }
})


app.mount('#app');


router.beforeEach((to, from, next) => {
    //if (to.meta.requiresAuth && (localStorage.getItem('token') === null || localStorage.getItem('token') === '')) {
        //next('/sign-in');
    //} else {
        // if user logged in 
        if(localStorage.getItem("ls_data")) {
            let userData = JSON.parse(localStorage.getItem("ls_data"));
            var current_step_no = userData.current_step_no;
            var change_password_at_login = parseInt(userData.change_password_at_login);
            if(userData && change_password_at_login) {
                if(to.path === '/edit-profile/change-password') {
                    next();
                }
            } else {
                if(to.path != '/sign-up/services' && current_step_no == "1"){
                    //next('/sign-up/services');
                    window.location = process.env.BASE_URL + 'sign-up/services';
                } else if(to.path != '/sign-up/payment' && current_step_no == "2"){
                    //next('/sign-up/payment');
                    if(to.path == '/paypal-error' || to.path == '/paypal-success'){
                        next();
                    }else{
                        window.location = process.env.BASE_URL + 'sign-up/payment';
                    }
                }else{
                    next();
                }                
            }
        } else {
            // if user not logged in
            if(to.path == '/sign-up/services' || to.path == '/sign-up/payment'){
                next('/sign-in');    
            } else {
                next();
            }
        }
    //}
})